import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
const externalLinks = [['Reseñas', 'http://reseniasbds.blogspot.com/'], ['Agenda', 'http://agendabds.blogspot.com/'], ['Podcast', 'https://open.spotify.com/show/3cGpRjVYLKGsQOVcy84snX']];
export default function NavBar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);
  return <header className="site-header">
            <a className="skip-link" href="#contenido">Saltar al contenido</a>
            <div className="header-inner">
                <Link to="/" className="wordmark" aria-label="Boca de Sapo, inicio">BOCA DE SAPO</Link>
                <button className="menu-toggle" aria-expanded={open} aria-controls="main-navigation" onClick={() => setOpen(!open)}>{open ? 'Cerrar ×' : 'Menú ☰'}</button>
                <nav id="main-navigation" className={`main-navigation ${open ? 'is-open' : ''}`} aria-label="Navegación principal" onKeyDown={event => {
        if (event.key === 'Escape') setOpen(false);
      }}>
                    <NavLink to="/" end>Inicio</NavLink>
                    <NavLink to="/numeros">Números</NavLink>
                    {externalLinks.map(([label, href]) => <a key={label} href={href} target="_blank" rel="noopener noreferrer">{label}<span className="external-arrow" aria-hidden="true">↗</span></a>)}
                    <NavLink to="/acercade">Staff</NavLink>
                    <NavLink to="/contacto" className="nav-contact">Contacto <span aria-hidden="true">↗</span></NavLink>
                </nav>
            </div>
        </header>;
}
